import React, { useState } from "react";

import { Button, ButtonToolbar, Form, InputGroup, Loader, Uploader, RadioGroup, Radio } from "rsuite";
import Modal from "rsuite/Modal";
import { useFormik } from "formik";

import { rsuiteInputOnchangeFormikHandler, rsuiteUploadFormikHandler } from "util/Helper";
import {validationSchema} from "./validatonSchemas";
import useRequestHandler from "hooks/useRequestHandler";

const FILE_SIZE = 1073741824;

const ImportBed = ({ auth, facilityId, modalOpen, setModalOpen, refreshData, data }) => { 
    
    const [loaderContent, setLoaderContent] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const importBedRequest = useRequestHandler({
        auth,
        apiArguments: [facilityId],
        apiName: "importBed",
        successMessageData: {
            message: "File was successfully imported",
            duration: 3000
        },
        errorMessageData: {
            title: "Error",
            message: "File could not be imported. Please try again. CSV format is allowed. Allowed file size is 1 GB",
            type: "error"
        }
    });

    const {values, errors, touched, resetForm, handleChange, handleSubmit} = useFormik({
        initialValues: {
            csvData: null,
            overwrite: "false",
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {

            setLoaderContent("Importing data");
            setIsLoading(true);

            await importBedRequest(
                async () => {
                    resetForm();
                    await refreshData();
                    setModalOpen(false);
                },
                null,
                [{ data: values.csvData.base64, overwrite:values.overwrite }]
            )
            setIsLoading(false);
        },
    });

    const closeModal = (e) => {
        resetForm();
        setModalOpen(false);
    };

    const formikOnInputChange = rsuiteInputOnchangeFormikHandler(handleChange);
    const formikOnUploaderChange = rsuiteUploadFormikHandler(handleChange, "csvData");

    return (
        <Modal open={modalOpen} onClose={closeModal} className="import-modal">
            <Modal.Header>
                <Modal.Title><strong>Import Beds</strong></Modal.Title>
            </Modal.Header>

            {isLoading &&
                <div className="loader-wrapper">
                    <Loader size="lg" center content={loaderContent} />
                </div>}

            <Modal.Body className={isLoading ? "hidden" : ""}>
                <Form fluid onSubmit={handleSubmit}>

                    <Form.Group controlId="csvData">

                        <InputGroup>
                            <Form.Control
                                className={"import-bed-input"}
                                type="text"
                                name="csvData"
                                placeholder="Select .csv file for import"
                                value={values.csvData?.name}
                                errorMessage={touched.csvData && errors.csvData ? errors.csvData : null}
                            />
                            <InputGroup.Addon>
                                <Uploader
                                    autoUpload={false}
                                    maxPreviewFileSize={FILE_SIZE}
                                    accept=".csv"
                                    action=""
                                    name="csvData"
                                    fileListVisible={false}
                                    onChange={formikOnUploaderChange}
                                >
                                    <Button> Browser</Button>
                                </Uploader>
                            </InputGroup.Addon>
                        </InputGroup>
                    </Form.Group>

                    {!!data.length && (<Form.Group controlId="overwrite">
                        <Form.Control
                            accepter={RadioGroup}
                            name="overwrite"
                            value={values.overwrite}
                            onChange={formikOnInputChange}
                            className={"import-bed-input"}
                            errorMessage={touched.overwrite && errors.overwrite ? errors.overwrite : null}
                        >
                            <Radio value="false">Append To Bed List</Radio>
                            <Radio value="true">Overwrite Bed List</Radio>
                        </Form.Control>

                    </Form.Group>)}

                    <Form.Group controlId="bth-toolbar">
                        <ButtonToolbar className="btn-toolbar">
                            <Button
                                type="reset"
                                appearance="ghost"
                                size="lg"
                                className="import-bed-btn btn-cancel"
                                onClick={closeModal}
                            >Cancel</Button>
                            <Button
                                type="submit"
                                appearance="primary"
                                size="lg"
                                className="import-bed-btn btn-save"
                            >Import</Button>
                        </ButtonToolbar>
                    </Form.Group>
                </Form>
            </Modal.Body>
        </Modal>
    )
}
ImportBed.defaultProps = {
    modalOpen: true,
    setModalOpen: () => {},
    refreshData: () => {},
    data: [],
}

export default ImportBed;